import { ICommunity, IExclusiveContent } from '@search/services';

const encodePathSegment = (segment: string) => encodeURIComponent(segment);

export const DynamicRouteBuilder = {
  creatorBySlug: (creatorRouteKey: string) => `/creators/${encodePathSegment(creatorRouteKey)}`,
  chats: (creatorRouteKey: string) => `/creators/${encodePathSegment(creatorRouteKey)}/chats`,
  communityBySlug: (creatorRouteKey: string, communitySlug: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/communities/${encodePathSegment(
      communitySlug,
    )}`,
  postBySlug: (creatorRouteKey: string, communitySlug: string, postSlug: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/communities/${encodePathSegment(
      communitySlug,
    )}/posts/${encodePathSegment(postSlug)}`,
  commentBySlug: (
    creatorRouteKey: string,
    communitySlug: string,
    postSlug: string,
    commentSlug: string,
  ) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/communities/${encodePathSegment(
      communitySlug,
    )}/posts/${encodePathSegment(postSlug)}/comments/${encodePathSegment(commentSlug)}`,
  replyBySlug: (
    creatorRouteKey: string,
    communitySlug: string,
    postSlug: string,
    parentCommentSlug: string,
    replySlug: string,
  ) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/communities/${encodePathSegment(
      communitySlug,
    )}/posts/${encodePathSegment(postSlug)}/comments/${encodePathSegment(
      parentCommentSlug,
    )}/replies/${encodePathSegment(replySlug)}`,
  challenges: (creatorRouteKey: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/challenges`,
  contents: (creatorRouteKey: string) => `/creators/${encodePathSegment(creatorRouteKey)}/contents`,
  contentBySlug: (creatorRouteKey: string, contentSlug: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/contents/${encodePathSegment(contentSlug)}`,
  badges: (creatorRouteKey: string) => `/creators/${encodePathSegment(creatorRouteKey)}/badges`,
  leaderboards: (creatorRouteKey: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/leaderboards`,
  about: (creatorRouteKey: string) => `/creators/${encodePathSegment(creatorRouteKey)}/about`,
  fanBySlug: (creatorRouteKey: string, fanId: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/fans/${encodePathSegment(fanId)}`,
  topicBySlug: (creatorRouteKey: string, topicSlug: string) =>
    `/creators/${encodePathSegment(creatorRouteKey)}/topics/${encodePathSegment(topicSlug)}`,
};

type RouteBuilder = (item: any, isCreator: boolean) => string;

export const searchRoutes: Record<string, RouteBuilder> = {
  community: (item: ICommunity, isCreator) => {
    const slug = item.slug ?? item.id;
    const mainPostRef = item.parent_post_slug;

    if (isCreator) {
      let path = '/dashboard/community/post/';
      if (!item.post) {
        path += item.thread_deepness === 1 ? 'comment/' : 'comment/reply/';
      }
      return `${path}?slug=${slug}&main_post_ref=${mainPostRef}&scroll=scroll`;
    }

    // Non-creator
    if (item.post) {
      return `/creators/${item.creator_display_name}/communities/${
        item.conversation_id ?? item.id
      }/posts/${slug}`;
    }

    if (
      item.thread_deepness === 1 &&
      item.creator_display_name &&
      item.conversation_id &&
      mainPostRef
    ) {
      return DynamicRouteBuilder.commentBySlug(
        item.creator_display_name,
        item.conversation_id,
        mainPostRef,
        slug,
      );
    }

    const base = item.thread_deepness === 1 ? 'comment' : 'comment/reply';
    return `/creator/community/post/${base}/?slug=${slug}&main_post_ref=${mainPostRef}&scroll=scroll`;
  },

  exclusive_content: (item: IExclusiveContent, isCreator) => {
    if (isCreator) {
      return `/dashboard/contents/editor/?id=${item.id}`;
    }
    return DynamicRouteBuilder.contentBySlug(item.creator_display_name, item.slug);
  },
};
